import { render } from "./EditAnEventPage.vue?vue&type=template&id=52a2a9cd&ts=true"
import script from "./EditAnEventPage.vue?vue&type=script&lang=ts"
export * from "./EditAnEventPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__